
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48.34 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.58 27.96c2.38-2.95 3.81-6.69 3.81-10.77C34.39 7.71 26.67 0 17.19 0S0 7.71 0 17.19s7.71 17.19 17.19 17.19c3.82 0 7.34-1.27 10.2-3.38l17.73 18.99 3.22-3.01-17.76-19.03zM2.65 17.19c0-8.02 6.53-14.55 14.55-14.55s14.55 6.53 14.55 14.55-6.53 14.55-14.55 14.55S2.65 25.22 2.65 17.19z","data-name":"Layer_1"}})])
          )
        }
      }
    